import React from "react";

const BagIcon = ({ cls }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <path
        d="M17.8333 5.83333H16.9167C16.7233 4.89284 16.2115 4.04779 15.4677 3.4406C14.7239 2.83341 13.7935 2.50121 12.8333 2.5L11.1667 2.5C10.2065 2.50121 9.2761 2.83341 8.53229 3.4406C7.78848 4.04779 7.27675 4.89284 7.08333 5.83333H6.16667C5.062 5.83466 4.00296 6.27407 3.22185 7.05518C2.44073 7.8363 2.00132 8.89534 2 10L2 18.3333C2.00132 19.438 2.44073 20.497 3.22185 21.2782C4.00296 22.0593 5.062 22.4987 6.16667 22.5H17.8333C18.938 22.4987 19.997 22.0593 20.7782 21.2782C21.5593 20.497 21.9987 19.438 22 18.3333V10C21.9987 8.89534 21.5593 7.8363 20.7782 7.05518C19.997 6.27407 18.938 5.83466 17.8333 5.83333ZM11.1667 4.16667H12.8333C13.3485 4.1688 13.8505 4.33007 14.2706 4.62841C14.6906 4.92674 15.0083 5.34758 15.18 5.83333H8.82C8.99174 5.34758 9.30936 4.92674 9.72942 4.62841C10.1495 4.33007 10.6514 4.1688 11.1667 4.16667ZM6.16667 7.5H17.8333C18.4964 7.5 19.1323 7.76339 19.6011 8.23223C20.0699 8.70107 20.3333 9.33696 20.3333 10V12.5H3.66667V10C3.66667 9.33696 3.93006 8.70107 4.3989 8.23223C4.86774 7.76339 5.50363 7.5 6.16667 7.5ZM17.8333 20.8333H6.16667C5.50363 20.8333 4.86774 20.5699 4.3989 20.1011C3.93006 19.6323 3.66667 18.9964 3.66667 18.3333V14.1667H11.1667V15C11.1667 15.221 11.2545 15.433 11.4107 15.5893C11.567 15.7455 11.779 15.8333 12 15.8333C12.221 15.8333 12.433 15.7455 12.5893 15.5893C12.7455 15.433 12.8333 15.221 12.8333 15V14.1667H20.3333V18.3333C20.3333 18.9964 20.0699 19.6323 19.6011 20.1011C19.1323 20.5699 18.4964 20.8333 17.8333 20.8333Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default BagIcon;
